// @flow
import React, { PureComponent } from 'react';
import { View, FlatList, StyleSheet, Text } from 'react-native';
import { SearchInput } from '../../components/common';
import CountryRow from './components/CountryRow';
import type { CountryType } from '../../config/iddCountries';
import { compareCountries } from '../../lib/country-utils';
import I18n from '../../lib/i18n';

class SelectCountry extends PureComponent<Props, State> {
  state: State = { countryFilter: '' };
  styles = getStyles();

  renderCountry = ({ item: country }: { item: CountryType }) => (
    <CountryRow country={country} onSelect={this.props.selectCountry} />
  );

  setCountryFilter = (countryFilter: string) => {
    this.setState({ countryFilter });
  };

  showNotAvailable = (countries: CountryType) => {
    const styles = this.styles;
    if (countries.length === 0) {
      return <Text style={styles.text}>{I18n.t('NoInternationalOffer.serviceUnavailable')}</Text>;
    }
    return null;
  };

  countryIncludesFilter = (country: CountryType): boolean =>
    country.name
      .trim()
      .toLowerCase()
      .includes(this.state.countryFilter.trim().toLowerCase());

  extractCountryId = (country: CountryType): string => country.id;

  // fixes lag when rendering the first time /!\ adapt height
  getCountryLayout = (country: CountryType, index: number) => ({ length: 50, offset: 50 * index, index });

  render() {
    const styles = this.styles;
    const countries = this.props.initialCountries.filter(this.countryIncludesFilter).sort(compareCountries);
    return (
      <View>
        <SearchInput onChangeText={this.setCountryFilter} value={this.state.countryFilter} />
        <FlatList
          contentContainerStyle={styles.container}
          renderItem={this.renderCountry}
          data={countries}
          keyExtractor={this.extractCountryId}
          showsVerticalScrollIndicator={false}
          getItemLayout={this.getCountryLayout}
          initialNumToRender={17}
        />
        {this.showNotAvailable(countries)}
      </View>
    );
  }
}

type Props = DispatchProps & StateProps;

export type DispatchProps = {
  selectCountry: CountryType => any,
};

export type StateProps = {
  initialCountries: CountryType[],
};

type State = {
  countryFilter: string,
};

function getStyles() {
  return StyleSheet.create({
    container: {
      paddingTop: 10,
      paddingBottom: 70,
    },
    text: {
      color: 'grey',
      fontSize: 13,
      textAlign: 'center',
    },
  });
}

export default SelectCountry;
